export default "__VITE_ASSET__CvT3va6C__"